/**
 *
 * Asynchronously loads the component for Reports
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
